import { render } from "./DesignFooter.vue?vue&type=template&id=5304992a&scoped=true"
import script from "./DesignFooter.vue?vue&type=script&lang=js"
export * from "./DesignFooter.vue?vue&type=script&lang=js"

import "./DesignFooter.vue?vue&type=style&index=0&id=5304992a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5304992a"]])

export default __exports__